import React from 'react';

const CANCHAS = [
  { nombre: 'Suprema Corte', key: 'suprema_corte', color: '#8683cf' },
  { nombre: 'Tribunal de Disciplina', key: 'tribunal_disciplina', color: '#85c9bd' },
  { nombre: 'Tribunal Electoral', key: 'tribunal_electoral', color: '#3f7f99' },
];

function PantallaInicial({ onSeleccionCancha, onIrASeleccion }) {
  return (
    <div className="pantalla-inicial">
      <h1>Cancha Electoral</h1>
      <div className="canchas-grid">
        {CANCHAS.map((cancha, idx) => (
          <React.Fragment key={cancha.key}>
            <button
              className="cancha-btn"
              onClick={() => onSeleccionCancha(cancha.key)}
              style={{ 
                borderColor: cancha.color,
                backgroundColor: `${cancha.color}15`
              }}
            >
              <div className="cancha-icon">
                <img src="/assets/img/Cancha.webp" alt="Cancha" style={{ width: '100%', height: 'auto' }} />
                <div className="cancha-nombre">{cancha.nombre}</div>
              </div>
            </button>
          </React.Fragment>
        ))}
      </div>

      <button 
        className="boton-flotante-seleccion boton-imagen-seleccion"
        onClick={onIrASeleccion}
        style={{
          background: 'transparent',
          border: 'none',
          boxShadow: 'none',
          padding: 0,
          margin: 0,
          display: 'inline-block',
          position: 'relative',
          width: 320,
          height: 112,
        }}
      >
        <span style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontWeight: 700,
          fontSize: '1.4em',
          textShadow: '0 2px 8px #222, 0 0 8px #000, 0 1px 0 #fff4',
          pointerEvents: 'none',
          zIndex: 2,
        }}>Selección</span>
        <img src="/assets/img/seleccion.webp" alt="Selección" style={{width: 320, height: 112, display: 'block', borderRadius: 0}} />
      </button>

      <style jsx>{`
        .pantalla-inicial {
          padding: 1rem;
          max-width: 100%;
          margin: 0 auto;
          min-height: 100vh;
          background: linear-gradient(to bottom, #87CEEB, #000080);
          position: relative;
        }

        h1 {
          text-align: center;
          font-size: 1.8rem;
          margin-bottom: 2rem;
          color: white;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        }

        .canchas-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 0.5rem;
          padding: 0.5rem;
        }

        .cancha-btn {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0.3rem;
          border: 6px solid;
          border-radius: 6px;
          background: white;
          cursor: pointer;
          transition: all 0.2s;
          width: 100%;
        }

        .cancha-btn:hover {
          transform: scale(1.02);
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        }

        .cancha-icon {
          position: relative;
          width: 100%;
          margin-bottom: 0.2rem;
        }

        .cancha-nombre {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: White;
          text-align: center;
          font-weight: bold;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
          width: 90%;
          font-size: 1.2rem;
          font-family: 'Courier New', monospace;
          letter-spacing: 1px;
          text-transform: uppercase;
          image-rendering: pixelated;
          -webkit-font-smoothing: none;
        }

        .boton-flotante-seleccion {
          position: fixed;
          bottom: 24px;
          left: 50%;
          transform: translateX(-50%);
          background: linear-gradient(90deg, #87ceeb 0%, #000080 100%);
          color: white;
          border: none;
          border-radius: 32px;
          padding: 16px 48px;
          font-size: 1.4rem;
          font-weight: 600;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: all 0.2s;
          z-index: 1000;
        }

        .boton-flotante-seleccion:hover {
          transform: translateX(-50%) translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
          background: linear-gradient(90deg, #00bfff 0%, #000080 100%);
        }

        @media (max-width: 480px) {
          .pantalla-inicial {
            padding: 0.3rem;
          }

          h1 {
            font-size: 1.3rem;
            margin-bottom: 1rem;
          }

          .canchas-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 0.3rem;
          }

          .cancha-btn {
            padding: 0.2rem;
            border-width: 1px;
          }

          .cancha-nombre {
            font-size: 0.8rem;
            letter-spacing: 0.5px;
          }

          .boton-flotante-seleccion {
            bottom: 16px;
            padding: 12px 36px;
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  );
}

export default PantallaInicial; 